import React from "react";
import { MoveHorizontal } from "lucide-react";

const COLUMNS = [
  { id: "30", size: "30 mm", inch: "1.18\"", models: ["S19 Pro", "L7", "X5"] },
  { id: "60", size: "60 mm", inch: "2.36\"", models: ["S21", "S19K Pro", "S19 XP", "S19j (Pro)", "S19a (Pro)", "S19", "L9", "D7 / D9"] },
  { id: "90", size: "90 mm", inch: "3.54\"", models: ["S19 (93/95TH)", "KS3", "KS5 (Pro)", "AL1 (Pro)", "DR7", "K7", "KA3"] },
];

const PsuSizingGuide = ({ selected }) => (
  <div data-testid="psu-sizing-guide" className="rounded-sm border border-[#27272A] bg-[#0E0E11]">
    <div className="flex items-center gap-2 border-b border-[#27272A] px-4 py-3">
      <MoveHorizontal size={16} className="text-primary" />
      <span className="font-mono text-xs uppercase tracking-[0.2em] text-primary">PSU Intake Sizing</span>
      <span className="ml-auto text-xs text-[#A1A1AA]">Find your miner → pick the length</span>
    </div>
    <div className="grid grid-cols-1 gap-px bg-[#27272A] sm:grid-cols-3">
      {COLUMNS.map((col) => {
        const active = selected === col.id;
        return (
          <div
            key={col.id}
            data-testid={`psu-guide-col-${col.id}`}
            className={`p-4 transition-colors ${active ? "bg-[#F97316]/10" : "bg-[#0E0E11]"}`}
          >
            <div className="flex items-baseline gap-2">
              <span className={`font-heading text-2xl font-bold ${active ? "text-primary" : "text-[#FAFAFA]"}`}>
                {col.size}
              </span>
              <span className="font-mono text-xs text-[#A1A1AA]">{col.inch}</span>
            </div>
            <ul className="mt-3 space-y-1.5">
              {col.models.map((m) => (
                <li key={m} className="font-mono text-xs text-[#A1A1AA]">{m}</li>
              ))}
            </ul>
          </div>
        );
      })}
    </div>
    <p className="px-4 py-3 text-[11px] leading-relaxed text-[#52525B]">
      The PSU intake gap is the distance between the hashboard fan housing and the power supply.
      S19 (90TH) has 86W/TH and 34.5W/TH subvariants using 60 mm and 90 mm respectively.
    </p>
  </div>
);

export default PsuSizingGuide;
